import {
  convertConditionToCustomerListVars,
  useAccessCustomerSearchCondition,
  useCustomerListApi
} from '@/common/api/modules/customer'
import { useFirstLoading } from '@/common/api/search'
import { useSiteId } from '@/common/app/site'

import Area from '@/components/view/layouts/area/Area'
import Content from '@/components/view/layouts/page/Content'
import Main, { MainLayoutType } from '@/components/view/layouts/page/Main'
import PageListLoading from '@/components/view/molecules/loading/PageListLoading'
import PageListSearching from '@/components/view/molecules/loading/PageListSearching'
import NoResultGuidance from '@/components/view/molecules/search/NoResultGuidance'
import PageTitle from '@/components/view/molecules/title/PageTitle'

import AppTitleBadge from '@/components/container/layout/AppTitleBadge'
import AccessCustomerModalProvider from '@/components/container/modal/accessCustomer/AccessCustomerModalProvider'
import VisitorSummaryPanel from '@/components/container/modules/recommend/customer/summary/VisitorSummaryPanel'
import AccessCustomerListTable from '@/components/container/modules/recommend/customer/table/AccessCustomerListTable'
import AccessCustomerSearchConditionField from '@/components/container/modules/recommend/customer/table/AccessCustomerSearchConditionField'
import TitlePageInfo from '@/components/container/utils/pager/TitlePageInfo'

const AccessCustomerListPage = () => {
  const siteId = useSiteId()
  const [condition, setCondition, onUpdatePage] = useAccessCustomerSearchCondition()

  const { data, isLoading } = useCustomerListApi(
    convertConditionToCustomerListVars(siteId, condition)
  )

  const isFirstLoading = useFirstLoading(isLoading)

  return (
    <AccessCustomerModalProvider>
      <Main type={MainLayoutType.FULL}>
        <PageTitle
          title='訪問者履歴'
          badgeNode={<AppTitleBadge type='recommend' />}
          description='クッキーベースの訪問者データと会員情報'
          behindNode={
            data && (
              <TitlePageInfo
                page={condition.page}
                perPage={condition.perPage}
                total={data.total}
                unit='件'
              />
            )
          }
        />

        {isFirstLoading ? (
          <PageListLoading />
        ) : (
          <>
            <Content>
              <VisitorSummaryPanel siteId={siteId} />
              <Area tableWrap noBorder>
                <AccessCustomerSearchConditionField
                  condition={condition}
                  setCondition={setCondition}
                />
                {isLoading ? (
                  <PageListSearching />
                ) : data?.total ? (
                  <>
                    <AccessCustomerListTable
                      customers={data ? data.customers : []}
                      condition={condition}
                      setCondition={setCondition}
                      onUpdatePage={onUpdatePage}
                      total={data.total}
                    />
                  </>
                ) : (
                  <NoResultGuidance searched name='訪問者' />
                )}
              </Area>
            </Content>
          </>
        )}
      </Main>
    </AccessCustomerModalProvider>
  )
}

export default AccessCustomerListPage
